export default __webpack_public_path__ + "static/media/pg-24.939c3278.jpg";